export { useLanguagesQuery, GET_LANGUAGES } from './useLanguagesQuery'
